import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"data-icon": "delete-1",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.85156 6.10345V3H15.1479V6.10345",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 6.10345H3.5",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6109 7.96558L17.771 19.5588C17.7426 19.9502 17.5649 20.3165 17.2736 20.5839C16.9823 20.8513 16.599 21 16.201 21.0001H7.79858C7.40053 21 7.01726 20.8513 6.72596 20.5839C6.43465 20.3165 6.25694 19.9502 6.2286 19.5588L5.38867 7.96558",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDelete1;
